import React from "react";
import {
  Modal,
  Input,
  Form,
  Select,
  Icon,
  DatePicker,
  Tabs,
  Button,
  Tag,
  message,
  Checkbox,
} from "antd";
import Footer from "./ViewModal/Footer";
import Productos from "./ViewModal/Productos";
import Referencias from "./ViewModal/Referencias";
import MetodoPago from "./ViewModal/MetodoPago";
import Cuotas from "./ViewModal/Cuotas";
import {
  FACTURA,
  BOLETA_DE_VENTA,
  NOTA_DE_CREDITO,
  NOTA_DE_DEBITO,
} from "../../../common/types/tipoComprobanteType";
const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
  constructor(props) {
    
    super(props);
    this.state = {};
  }

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
};


  render() {

    const {
      getFieldDecorator,
      setFieldsValue,
      getFieldValue,
    } = this.props.form;


    return (
      <Modal
        title={`Ver Compra`}
        visible={this.props.visible}
        onCancel={this.props.onClose}
        footer={[
          <Button
              key="1"
              onClick={this.props.onClose}
          >
              Cancelar
          </Button>
      ]}
        style={{ top: 30 }}
        width="1100px"
      >
        <Form>
          <div className="row">
            <div className="col-md-4 form-group">
              <Form.Item label="Fecha / Tipo de Cambio">
                <InputGroup compact>
                  <Input
                    readOnly
                    style={{ width: "65%" }}
                    value={this.props.formValues.fechaStr}
                    suffix={
                      <Icon
                        type="calendar"
                        style={{ color: "rgba(0,0,0,.25)" }}
                      />
                    }
                  />
                  <Input
                    readOnly
                    style={{ width: "35%" }}
                    value={this.props.formValues.tipoCambio}
                  />
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Días / Fecha de Vencimiento">
                <InputGroup compact>
                  <Input
                    readOnly
                    style={{ width: "35%" }}
                    value={this.props.formValues.diasVencimiento}
                  />
                  <Input
                    readOnly
                    style={{ width: "65%" }}
                    value={this.props.formValues.fechaVencimientoStr}
                  />
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-4 form-group">
              <Form.Item label="Fecha de Registro">
                <InputGroup compact>
                  <Input
                    readOnly
                    style={{ width: "100%" }}
                    value={this.props.formValues.fechaDocumentoStr}
                  />
                </InputGroup>
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8 form-group">
              <Form.Item label="Proveedor">
                <InputGroup compact>
                  <Input
                    readOnly
                    style={{ width: "20%" }}
                    value={this.props.formValues.numeroDocumentoProveedor}
                  />
                  <Input
                    readOnly
                    style={{ width: "80%" }}
                    value={this.props.formValues.nombreProveedor}
                  />
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Fecha de Recepción">
                <InputGroup compact>
                  <Input
                    readOnly
                    style={{ width: "100%" }}
                    value={this.props.formValues.fechaRecepcionStr}
                  />
                </InputGroup>
              </Form.Item>
            </div>
          </div>

          <div className="row">
          <div className="col-md-4 form-group">
              <Form.Item label="Tipo">
              <Input
                  readOnly
                  value={this.props.formValues.idTipoActividad == 1 ? "SERVICIO" : this.props.formValues.idTipoActividad == 2 ? "BIENES" : "ACTIVO"}
                />
              </Form.Item>
            </div>


            <div className="col-md-4 form-group">
              <Form.Item label="Tipo Comprobante">
                <Input
                  readOnly
                  value={this.props.formValues.nombreTipoComprobante}
                />
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Serie / Documento">
                <InputGroup compact>
                  <Input
                    readOnly
                    style={{ width: "40%" }}
                    value={this.props.formValues.serie}
                  />
                  <Input
                    readOnly
                    style={{ width: "60%" }}
                    value={this.props.formValues.documento}
                  />
                </InputGroup>
              </Form.Item>
            </div>

   
          </div>

          <div className="row">
            <div className="col-md-4 form-group">
              <Form.Item label="Establecimiento">
                <Input
                  readOnly
                  value={this.props.formValues.nombreEstablecimiento}
                />
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Tipo Almacén">
                <Input readOnly value={this.props.formValues.tipoAlmacen} />
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Almacén">
                <Input readOnly value={this.props.formValues.nombreAlmacen} />
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Moneda">
                <Input readOnly value={this.props.formValues.nombreMoneda} />
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Forma de Pago">
                <Input readOnly value={this.props.formValues.idFormaPago== 1 ? "CONTADO":"CREDITO"} />
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Estado de Pago">
                <Input readOnly value={this.props.formValues.idPendiente== 1 ? "PENDIENTE":"CANCELADO"} />
              </Form.Item>
            </div>

          </div>

          <div className="row">
            <div className="col-md-8 form-group">
              <Form.Item label="Observación">
                <Input readOnly value={this.props.formValues.observacion} />
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Proyecto">
                <Input readOnly value={this.props.formValues.nombreProyecto} />
              </Form.Item>
            </div>

            {this.props.formValues.idTipoComprobante == NOTA_DE_CREDITO.ID ? (
              <div className="col-md-4 form-group">

                <Form.Item label="Motivo">
                  {getFieldDecorator("idMotivoNotaCredito", {
                    initialValue: this.props.formValues.idMotivoNotaCredito
                      ? { key: this.props.formValues.idMotivoNotaCredito }
                      : undefined
                  })(
                    <Select
                      showSearch
                      open={false}
                      labelInValue
                      placeholder={"Seleccione Motivo"}
                      optionFilterProp="children"
                      onChange={(option) => this.props.onChange("idMotivoNotaCredito", option.key, this.props.form)}
                    >
                      {this.props.formValues.motivos.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>

              </div>
            ) : null
            }
          </div>

          <div className="row">
            <div className="col-md-12 form-group">
              <Tabs>
                <TabPane tab="Detalle de Productos y Servicios" key="1">
                  <Productos dataSource={this.props.formValues.detalles} />
                </TabPane>
                <TabPane tab="Detalle de Referencias" key="2">
                  <Referencias dataSource={this.props.formValues.referencias} />
                </TabPane>

                 {/* CREDITO */}
                {this.props.formValues.idFormaPago == 2 ? (
                  <TabPane tab="Detalle de Cuotas" key="3">
                    <Cuotas dataSource={this.props.formValues.cuotas} />
                  </TabPane>
                ) :

                  <TabPane tab="Método de Pago" key="4">
                    <MetodoPago dataSource={this.props.formValues.metodosPagos} />
                  </TabPane>
                }   

              </Tabs>
            </div>
          </div>
          <Footer formValues={this.props.formValues} />
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(FormModal);
